export default __webpack_public_path__ + "static/media/spark_77.ee503fea.png";